export default "__VITE_PUBLIC_ASSET__5c220321__"